import { FeedRunCard } from "@signalist/shared-types";

/**
 * Stable numeric identity of a feed card for FE state — the docked-panel selection
 * (`selectedCardId`), the per-card person switch (`selectedPersonByRunId`) and React keys.
 *
 * A run-backed card is identified by its `runId`. A **runless** card (PREC-3584 — a company
 * with qualifying leads but no `tracker_signal_run` yet) has `runId === null`, so it falls back
 * to the negated `trackerOrganizationId`: always present, unique per card (the feed shows one
 * card per organization) and guaranteed disjoint from the positive auto-increment run ids, so
 * the two identity spaces never collide. `runId` itself stays reserved for the ignore/undo API,
 * which only a run-backed card exposes.
 */
export const feedIdentity = (runId: number | null, trackerOrganizationId: number): number =>
	runId ?? -trackerOrganizationId;

export const feedCardKey = (card: Pick<FeedRunCard, "runId" | "company">): number =>
	feedIdentity(card.runId, card.company.trackerOrganizationId);
